<template>
  <div
    class="system-edit-box"
  >
    <a-alert
      v-if="tabName==='sms'"
      :message="alertTip"
      type="warning"
      show-icon
    />
    <a-form
      ref="systemForm"
      :form="form"
      :hide-required-mark="true"
      @submit.prevent="saveForm"
    >
      <a-form-item
        v-if="tabName!=='sms'"
        :label="`${templateTitTxt}：`"
        prop="title"
      >
        <a-input
          v-decorator="[
            'title',
            {rules: [{ required: true, message: templateTipTxt }], initialValue: rowData.title }
          ]"
          :disabled="isWexin"
          type="text"
        />
      </a-form-item>
      <a-form-item
        :label="`${templateConTit}：`"
        prop="template"
      >
        <system-editor
          ref="systemEdit"
          v-model="template"
          :class="[editClass, {'disabled-edit': ($store.state.baseinfo.private_cloud_status || isWexin)}]"
          :options="editOption"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        />
        <template v-if="!$store.state.baseinfo.private_cloud_status">
          <var-add
            v-if="!isWexin"
            :item="item"
            @getVar="setVar"
          />
        </template>
        <slot name="sms-tip" />
      </a-form-item>
      <a-form-item class="receive-row-item1">
        <div
          slot="label"
          class="clearfix"
        >
          <a-popover>
            <template slot="content">
              <p class="receive-content-tip">
                {{ $t('message["1289"]') }}
              </p>
            </template>
            <i
              class="icon iconfont iconicon-test34 tip-icon fl"
              style="margin-left: 0;margin-right:5px;"
            />
          </a-popover>
          <span class="fl"> {{ $t('message["510"]') }}：</span>
        </div>
        <a-checkbox-group
          v-decorator="['selectedreceive', {initialValue: rowData.selectedreceive}]"
        >
          <a-checkbox
            v-for="(val, key ) in checkboxList"
            :key="key"
            :value="val"
          >
            {{ getMembers(val) }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
      <div class="select-userid-box">
        <template>
          <receive
            v-if="isRole1"
            :item="item"
            :index="0"
          />
        </template>
        <template>
          <receive
            v-if="isRole2"
            :item="item"
            :index="1"
          />
        </template>
      </div>
      <a-form-item
        v-if="rowData.class !== 1 && rowData.noticetype !== '线索联系提醒'"
        :label="`${sendTimeTit}：`"
        prop="sendTimeType"
      >
        <a-radio-group
          v-decorator="['sendTimeType', {initialValue: rowData.sendperiod instanceof Array ? 1 : 0}]"
          @change="changeTimeType"
        >
          <a-radio
            :value="0"
          >
            {{ $t('message["904"]') }}
          </a-radio>
          <a-radio
            :value="1"
          >
            <a-time-picker
              :value="moment(startTime, 'HH:mm:ss')"
              format="HH:mm:ss"
              @change="onChange"
            />
            <span style="margin: 0 12px;">{{ $t('message["1609"]') }}</span>
            <a-time-picker
              :value="moment(endTime, 'HH:mm:ss')"
              :disabled-hours="disHour"
              :disabled-minutes="disMinutes"
              format="HH:mm:ss"
              @change="onChange2"
            />
          </a-radio>
        </a-radio-group>
        <span
          class="audit"
        >
          <a-tooltip placement="right">
            <template slot="title">
              <div
                slot="content"
                class="audit-tip-box"
              >
                {{ $t('message["530"]') }}
              </div>
            </template>
            <!-- <a-button class="tip-btn"><i class="icon iconfont icon-tip-notice-normal-gr tip-icon" /></a-button> -->
            <i class="icon iconfont iconicon-test34 tip-icon" />
          </a-tooltip>
        </span>
      </a-form-item>
      <div class="footer">
        <a-button
          type="primary"
          html-type="submit"
          @click="handleOk"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button
          :style="{marginRight: '8px'}"
          @click="handleCancel"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </a-form>
  </div>
</template>
<script>
import { getMembers } from '@/store/config/scripts.js'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { mapGetters, mapState, mapActions } from 'vuex'
import { quillEditor } from 'vue-quill-editor'
import moment from 'moment'
import VarAdd from './VarAdd'
import Receive from './Receive'
export default {
  components: {
    SystemEditor: quillEditor,
    VarAdd,
    Receive
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    editClass: {
      type: String,
      default: ''
    },
    editOption: {
      type: Object,
      default () {
        return {}
      }
    },
    hide: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      startTime: '00:00:00',
      endTime: '23:00:00',
      index: 0,
      content: '',
      receiveP: [],
      template: '',
      sendperiod: 0,
      sendTimeType: 0,
      formItemLayout: {
        labelCol: { span: 2 },
        wrapperCol: { span: 34 }
      }
    }
  },
  computed: {
    ...mapGetters('config/notice', ['currentData']),
    ...mapState('config/notice', ['tabName', 'setFetching']),
    rowData () {
      return this.item
    },
    limitTime () {
      let arr = this.startTime.split(':')
      let arrH = []
      let arrMinutes = []
      let arrSeconds = []
      for (let i = 0; i < arr[0]; i++) {
        arrH.push(i)
      }
      for (let j = 0; j < arr[1]; j++) {
        arrMinutes.push(j)
      }
      for (let k = 0; k < arr[2]; k++) {
        arrSeconds.push(k)
      }
      return {
        disH: arrH,
        disM: arrMinutes,
        disS: arrSeconds
      }
    },
    isWexin () {
      return this.tabName === 'wexin'
    },
    isRole1 () {
      return this.rowData.choicereceive.includes(9) && !!this.rowData.sysrole1.length
    },
    isRole2 () {
      return this.rowData.choicereceive.includes(10) && !!this.rowData.sysrole2.length
    },
    checkboxList () {
      return this.rowData.choicereceive.filter(item => (item !== 9 && item !== 10))
    },
    sendTimeTit () {
      return this.$t('message["278"]')
    },
    templateTitTxt () {
      return this.$t('message["648"]')
    },
    templateTipTxt () {
      return this.$t('message["649"]')
    },
    templateConTit () {
      return this.$t('message["650"]')
    },
    alertTip () {
      return this.$t('message["1639"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  mounted () {
    if (!this.setFetching) {
      this.selectedreceive = this.item.selectedreceive
      this.template = this.$filterXss.process(this.item.template)
      // this.template = this.item.template
      if (this.rowData.sendperiod instanceof Array) {
        this.sendTimeType = 1
        this.sendperiod = this.item.sendperiod
        this.startTime = this.sendperiod[0]
        this.endTime = this.sendperiod[1]
      } else {
        this.sendTimeType = 0
      }
    }
  },
  methods: {
    getMembers,
    moment,
    ...mapActions('config/notice', ['formSubmitAjax', 'fetchDatas']),
    setVar (item) {
      if (!this.isWexin) {
        let quill = this.$refs.systemEdit.quill
        let d = quill.insertText(this.index, item + '：{{' + item + '}}')
        // console.log(d.ops[0])
        // console.log(quill.selection.savedRange.index)
        if (d.ops.length > 1) {
          quill.setSelection(d.ops[0].retain + d.ops[1].insert.length)
        } else {
          quill.setSelection(quill.selection.savedRange.index + d.ops[0].insert.length)
        }
        quill.focus()
      } else {
        return false
      }
      // console.log(this.$refs.systemEdit.quill.getSelection())
    },
    onEditorFocus (e) {
      // console.log(e)
      this.index = e.getSelection().index
      if (this.$store.state.baseinfo.private_cloud_status) {
        this.$refs.systemEdit.quill.enable(false)
      }
      if (this.isWexin) {
        this.$refs.systemEdit.quill.enable(false)
      }
      // this.$refs.systemEdit.quill.enable(false)
    },
    onEditorChange (e) {
      let quill = this.$refs.systemEdit.quill
      if (quill.hasFocus()) {
        setTimeout(() => {
          this.index = quill.getSelection().index
        })
      }
    },
    async saveForm () {
      if (this.sendTimeType === 1) {
        this.sendperiod = [this.startTime, this.endTime]
      } else {
        this.sendperiod = 0
      }
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, { sendperiod: this.sendperiod, id: this.rowData.id, template: this.template, selecteduserid: this.rowData.selecteduserid })
          const chain = await this.formSubmitAjax()
          chain.params(obj)
            .onSuccess(async (raw) => {
              this.$message.success(this.$t('message["1389"]') + '！')
              const chain = await this.fetchDatas()
              chain.fetch()
              this.hide()
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    changeTimeType (val) {
      if (val.target.value * 1 === 1) {
        this.sendTimeType = 1
        this.sendperiod = [this.startTime, this.endTime]
      } else {
        this.sendTimeType = 0
        this.sendperiod = 0
      }
    },
    onChange (time, timeString) {
      this.value = time
      this.startTime = timeString
    },
    onChange2 (time, timeString) {
      this.value2 = time
      this.endTime = timeString
    },
    disHour () {
      return this.limitTime.disH
    },
    disMinutes (h) {
      const disH = this.startTime.split(':')
      if (h < disH[0] * 1 || (h === disH[0] * 1)) {
        return this.limitTime.disM
      } else {
        return []
      }
    },
    handleOk () {},
    handleCancel () {
      this.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
  .system-edit-box::v-deep {
    background: #fff;
    //padding: 0 24px;
    padding-bottom: 60px;
   .ant-form {
     padding-left: 56px;
   }
    .ant-alert-warning {
        margin: 0 -20px 24px -6px;
      }
    .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .receive-row-item1 {
    .ant-form-item-control-wrapper {
      border-bottom: 1px solid #ebebeb;
      padding-bottom: 24px;
    }
  }
  .receive-row-item1 label::after {
    content: '' !important;
  }
  .ant-row {
    padding-left: 100px;
    .ant-form-item-label {
      float: left;
      width: 80px;
      margin-left: -100px;
      label {
      color: #666;
      }
    }

    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
    }
  }

    .ant-input {
      width: 320px;
    }

    .edtior-system {
      width: 320px;
      border-top: 1px solid #ebebeb;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      display: inline-block;
      vertical-align: top;

      .ql-toolbar.ql-snow {
        display: none;
      }

      .ql-container {
        height: 164px;
      }
    }

    .edtior-wechat {
      width: 320px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      display: inline-block;
      vertical-align: top;

      .ql-container {
        height: 164px;
      }
    }

    .email-editor {
      width: 482px !important;
    }

    .disabled-edit {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #b3b3b3;

      .ql-disabled {
        cursor: not-allowed;

        .ql-editor {
          cursor: not-allowed;
        }
      }
    }

    .el-date-editor {
      .el-range-separator {
        line-height: 20px;
        width: 7%;
      }

      .el-range__icon {
        line-height: 20px;
      }

      .el-range__close-icon {
        display: none;
      }
    }
  }

  .icon-tip-notice-normal-gr,.iconicon-test34 {
    color: #b3b3b3;
    margin-left: 20px;
  }
  .receive-content-tip {
    width: 212px;
  }
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 16px 0 16px 180px;
    border-top: 1px solid $gray4;
    background: #fff;
  }
</style>
<style>

</style>
